import { env } from '../env';

/** Pilot entry points for the Kit Tracking tablet redesign (PTB-6559).
 *
 *  The redesign runs on a canary copy of this portal pointed at the same
 *  production API, so the floor can try it on real work. Production offers two
 *  ways in — the Operations header (PTB-6829) and the Floor menu (PTB-6854).
 *
 *  TURNING IT OFF is a config change, not a code change. The portal image
 *  injects env at container start (`vite-inject-env` writes `window.env`), so
 *  clearing `VITE_KT_PILOT_URL` in the chart values and running a helm upgrade
 *  removes both entry points — no rebuild, no redeploy of application code.
 *  That is the lever to pull when the redesign ships to production and the
 *  canary is retired.
 *
 *  It also hides itself on the canary host, so that build never links to
 *  itself, and it stays off anywhere the value is unset (local dev, staging).
 */
export const KT_PILOT_URL: string = env.VITE_KT_PILOT_URL ?? '';

const CANARY_HOST_PREFIX = 'shop-canary.';

const isCanaryHost = (): boolean =>
	typeof window !== 'undefined' &&
	window.location.hostname.startsWith(CANARY_HOST_PREFIX);

/** True when this build should advertise the pilot. */
export const isPilotEnabled = (): boolean =>
	KT_PILOT_URL !== '' && !isCanaryHost();
